import React from 'react';
import { useTranslation } from 'react-i18next';

import { PartBin } from '../../services/types';

interface PartBinsTableProps {
  partBins: PartBin[];
}

export const PartBinsTable: React.FC<PartBinsTableProps> = ({ partBins }) => {
  const { t } = useTranslation();

  const totalQty = partBins.reduce((sum, bin) => sum + bin.partBinOnhandQty, 0);

  return (
    <div className="bg-white rounded border border-gray-300 shadow-sm flex flex-col">
      {/* Header */}
      <div className="bg-green-50 px-4 py-3 border-b border-green-200 flex-shrink-0">
        <h3 className="text-lg font-bold text-green-900">
          {t('parts.warehouseBins')}
        </h3>
        <p className="text-xs text-green-700">
          {partBins.length}{' '}
          {partBins.length === 1 ? t('parts.bins') : t('parts.binPlural')}
          {totalQty > 0 && ` • Total: ${totalQty.toLocaleString()}`}
        </p>
      </div>

      {/* Content */}
      {partBins.length > 0 ? (
        <div className="overflow-x-auto flex-grow">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-100 border-b border-gray-200 sticky top-0">
                <th className="px-4 py-3 text-left font-semibold text-gray-700">
                  {t('parts.binLocation')}
                </th>
                <th className="px-4 py-3 text-right font-semibold text-gray-700">
                  {t('parts.onHandQty')}
                </th>
              </tr>
            </thead>
            <tbody>
              {partBins.map((bin, idx) => (
                <tr key={idx} className="hover:bg-gray-50 transition-colors">
                  <td className="px-4 py-3 text-gray-900 font-medium">
                    {bin.whseBinDescription}
                  </td>
                  <td className="px-4 py-3 text-right text-gray-900 font-semibold">
                    {bin.partBinOnhandQty.toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="p-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="pb-2">
              <p className="text-xs font-semibold text-gray-600 uppercase tracking-tight mb-1">
                {t('parts.binLocation')}
              </p>
              <p className="text-sm font-medium text-gray-900">-</p>
            </div>
            <div className="pb-2 text-right">
              <p className="text-xs font-semibold text-gray-600 uppercase tracking-tight mb-1">
                {t('parts.onHandQty')}
              </p>
              <p className="text-sm font-medium text-gray-900">0</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
